import { useContext } from 'react'
import { AppContext } from './../context/AppContext'
import { ColorModeContext } from '../context/ColorModeContext'

export default function Logo ({ style }) {
  const app = useContext(AppContext)
  const { colorMode } = useContext(ColorModeContext)
  const url = '/logo' + (colorMode === 'dark' ? '/dark' : '') + '/logo-greffe-' + app.greffe.code + '.png'

  return (
    <img
      src={url}
      width='227'
      alt='Logo du Greffe'
      style={{ ...style, display: 'block' }}
    />
  )
}
